<template>
  <v-container class="pa-0" fluid>
    <v-card>
      <v-card-text v-if="!isLoading">
        <v-row justify="end" no-gutters>
          <v-icon @click="() => $emit('close')">close</v-icon>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <div class="text-center">
              <v-img
                :src="photo"
                height="150"
                width="150"
                style="display: inline-block"
              ></v-img>
            </div>
          </v-col>
          <v-col class="text-center text-md-left" cols="12" md="8">
            <span class="text-h4">{{ student.firstName }}</span>
            <br />
            <span class="text-h5">{{ student.lastName }}</span>
            <br />
            <v-icon class="pb-2" v-if="student.genre === `MALE`">male</v-icon>
            <v-icon class="pb-2" v-else>female</v-icon>
            <span class="text-h6">{{
              student.age + " " + $t("student.years_old") + " "
            }}</span>
            <br />
            <span class="text-h6">{{ student.country }}</span>
            <br />
            <p class="subtitle-1 mb-0" v-if="student.tutors">
              {{ $t("student.prop.tutors") + ":" }}
            </p>
            <p
              class="subtitle-2 my-0"
              v-for="tutor in student.tutors"
              :key="tutor.id"
            >
              {{ tutor.fullName }} (
              {{ $t(`relationship.values.${tutor.relationship.name}`) }} )
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <loading-page v-else></loading-page>
    </v-card>
  </v-container>
</template>

<script>
import LoadingPage from "@/components/loading-page/LoadingPage.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";

const StudentEntityRepository = RepositoryFactory.get(
  "StudentEntityRepository"
);

export default {
  name: "StudentLectureDetails",
  components: { LoadingPage },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    photo: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      student: null,
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    },
  },
  created() {
    this.loading = true;
    StudentEntityRepository.getLectureStudentDetail(this.studentId)
      .then((res) => (this.student = res))
      .finally(() => (this.loading = false));
  },
};
</script>
